/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_MarchInputs */

const es_months_march = /** @type {(inputs: Months_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marzo`)
};

const en_months_march = /** @type {(inputs: Months_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`March`)
};

/**
* | output |
* | --- |
* | "March" |
*
* @param {Months_MarchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_march = /** @type {((inputs?: Months_MarchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_MarchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_march(inputs)
	return en_months_march(inputs)
});
export { months_march as "months.march" }